'use client'

import NewPlantModal from "../modals/newPlant";
import RegisterModal from "../modals/register";
import SignInModal from "../modals/signIn";
import SignOutModal from "../modals/signOut";
import { Session } from "next-auth";
import NewNoteModal from "../modals/newNote";
import { useStateStore } from "@/context/stateStore";
import NewPlantToGrowModel from "../modals/newCycle";

export default function ModalProvider({ session, handleUpdate }: { session: Session | null, handleUpdate: () => Promise<void> }) {

    //const plants = useStateStore(state => state.plants);
    //const activelyGrowing = useStateStore(state => state.activelyGrowing);
    //const notes = useStateStore(state => state.notes);
    const currPlant = useStateStore(state => state.currPlant);
    const currCycle = useStateStore(state => state.currCycle);

    return (
        <>
            <SignInModal session={session} handleUpdate={handleUpdate} />
            <SignOutModal session={session} handleUpdate={handleUpdate} />
            <RegisterModal session={session} handleUpdate={handleUpdate} />
            <NewPlantModal session={session} handleUpdate={handleUpdate} />
            <NewPlantToGrowModel session={session} handleUpdate={handleUpdate} currPlant={currPlant} />
            <NewNoteModal session={session} handleUpdate={handleUpdate} currPlant={currPlant} currCycle={currCycle} />
        </>
    );
}